import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-password-field',
  templateUrl: './password-field.component.html',
  styleUrl: './password-field.component.scss',
  providers:[
      {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => PasswordFieldComponent),
          multi: true
      }
  ]
})
export class PasswordFieldComponent implements ControlValueAccessor{
    @Input() value: string;
    @Output() valueChange: EventEmitter<string> = new EventEmitter();
    passwordTextType: boolean = false;
    public isDisabled: boolean;

    private onChange: (value: string) => void;
    private onTouched: (e) => void;

    writeValue(value: string): void {
        this.value = value
    }

    registerOnChange(fn: (e)=>void): void {
        this.onChange = fn;
    }
    registerOnTouched(fn: (e)=>void): void {
        this.onTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }


    togglePasswordTextType() {
        this.passwordTextType = !this.passwordTextType;
    }

    onModelChange($event: string) {
        this.valueChange.next($event);
        if (this.onChange) {
            this.onChange($event);
        }
    }

    onControlTouched(e) {
        if (this.onTouched) {
            this.onTouched(e);
        }
    }
}
